import { createApp } from 'vue';
import LandingPage from '../components/PrivacyPolicy/Index.vue';

// import InnerPage from '../components/InnerLocationPage/Index.vue';
// import ContactInnerForm from '../components/ContactInnerForm.vue';

const landing = createApp(LandingPage);
landing.mount('#privacyPolicy');
